import React from 'react';
import { Card } from '@/components/shared/card';
import ValueSlider from './ValueSlider';
import { Weights } from '@/types/opportunity';

interface ValueDimensionsCardProps {
  weights: Weights;
  onWeightChange: (key: keyof Weights, value: number[]) => void;
}

const valueDimensions = [
  { 
    key: 'SpeedUpPermitting', 
    label: 'Speed Up Permitting',
    tooltip: "Reduce the time it takes to process and approve permits through automation and streamlined workflows"
  },
  { 
    key: 'IncreaseStaffProductivity', 
    label: 'Increase Staff Productivity',
    tooltip: "Enable staff to handle more applications and tasks efficiently through AI-assisted workflows"
  },
  { 
    key: 'SimplifyApplicationExperience', 
    label: 'Simplify Application Experience',
    tooltip: "Make it easier for applicants to submit complete and accurate applications through guided processes"
  },
  { 
    key: 'EnhanceEquitableAccessToServices', 
    label: 'Enhance Equitable Access',
    tooltip: "Improve service accessibility for all community members regardless of technical expertise or language"
  },
  { 
    key: 'StrengthenInternalVisibilityDecisionMaking', 
    label: 'Strengthen Internal Visibility',
    tooltip: "Gain better insights into operations and enable data-driven decision making through analytics"
  },
  { 
    key: 'IncreaseProcessTransparency', 
    label: 'Increase Process Transparency',
    tooltip: "Provide clearer visibility into permit status and requirements for both staff and applicants"
  },
  { 
    key: 'BoostFinancialSustainability', 
    label: 'Boost Financial Sustainability',
    tooltip: "Improve revenue collection and reduce operational costs through process optimization"
  },
];

const ValueDimensionsCard = ({ weights, onWeightChange }: ValueDimensionsCardProps) => {
  return (
    <Card className="p-8">
      <h3 className="text-2xl md:text-3xl font-semibold mb-4">What are your most important goals?</h3>
      <p className="text-base md:text-lg text-gray-500 mb-8">
        Slide right for higher priority. These settings help identify AI solutions that align with your goals.
      </p>
      <div className="space-y-12">
        {valueDimensions.map(({ key, label, tooltip }) => (
          <ValueSlider
            key={key}
            label={label}
            tooltip={tooltip}
            value={weights[key as keyof typeof weights]}
            onChange={(value) => onWeightChange(key as keyof typeof weights, value)}
          />
        ))}
      </div>
    </Card>
  );
};

export default ValueDimensionsCard;